import BasicButton from "./BasicButton";
import Pagination from "./Pagination";

export { BasicButton, Pagination };

export default {
  BasicButton,
  Pagination,
};
